import { RetailStoreData } from './../../class/RetailStoreData';
import { OrderItem } from './../../class/OrderItem';
import { OrderInfo } from '../../class/OrderInfo';
import { OrderSub } from '../../class/OrderSub';
import { forkJoin } from 'rxjs';
import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SubService } from '../../service/sub.service';
import * as _ from 'lodash/core';

@Component({
  selector: 'app-final',
  templateUrl: './final.component.html',
  styleUrls: ['./final.component.scss']
})
export class FinalComponent implements OnInit {
  retailStore: RetailStoreData;
  orderInfo: OrderInfo;
  willRecieve: Array<OrderItem>;
  willNotRecieve: Array<OrderItem>;
  orderAddonItems: Array<OrderItem>;
  storeInfo: Ecom.StoreInfo;
  pageReady = false;
  drivingDirectionsLink: any;
  bagRecycleFeatBannerContent: SafeHtml;

  constructor(private subService: SubService, private sanitizer: DomSanitizer) {}

  ngOnInit() {
    const observable = [
      this.subService.getOrder(),
      this.subService.getSubs(),
      this.subService.getCustSubs(),
      this.subService.getBackupSubs(),
      this.subService.getOutOfStockItems(),
      this.subService.getAddonItems(),
      this.subService.getRetailStore()
    ];

    forkJoin(observable).subscribe((results: any) => {
      this.orderInfo = results[0];
      const orderSubs: Array<OrderSub> = results[1];
      const custSubs: Array<OrderSub> = results[2];
      const backupSubs: Array<OrderSub> = results[3];
      const orderOutOfStocks: Array<OrderItem> = results[4];
      this.orderAddonItems = results[5];
      this.retailStore = results[6];

      this.bagRecycleFeatBannerContent = this.sanitizer.sanitize(SecurityContext.HTML,this.retailStore.bagRecycleFeat.htmlBannerContent);

      this.willNotRecieve = orderOutOfStocks;
      this.willRecieve = [];

      _.forEach(orderSubs, (orderSub) => {
        if (orderSub.isSubApproved === 'Y') {
          this.willRecieve.push(orderSub.newItem);
        } else if (orderSub.isSubApproved === 'N') {
          this.willNotRecieve.unshift(orderSub.oldItem);
        }
      });

      if (this.retailStore.isCustomerChoiceEnabled) {

        _.forEach(backupSubs, (backupSub) => {
          if (backupSub.isSubApproved === 'Y') {
            this.willRecieve.push(backupSub.newItem);
          } else if (backupSub.isSubApproved === 'N') {
            this.willNotRecieve.unshift(backupSub.oldItem);
          }
        });

        _.forEach(custSubs, (custSub) => {
          this.willRecieve.push(custSub.newItem);
        });
    }

      this.pageReady = true;
    });

    this.subService.getStoreInfo().subscribe((storeInfo: Ecom.StoreInfo) => {
      this.storeInfo = storeInfo;

      // get driving directions link
      if (this.storeInfo && this.storeInfo.AppLinks) {
        this.drivingDirectionsLink = _.find(this.storeInfo.AppLinks, {
          Rel: 'driving-directions'
        });
      }
    });
  }
}
